import Breadcrumbs from "@bufox/schema-org-breadcrumbs"
import styled from "styled-components"

const ThemeBreadcrumbs = styled(Breadcrumbs)`
  display: inline-block;
  font-size: 0.8rem;
  li {
    display: inline-block;
    position: relative;
    margin-right: 1em;
    &::after {
      content: "";
      height: 1em;
      width: 1px;
      background-color: var(--secondary);
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0 auto;
      right: -0.5em;
    }
    &:last-child::after {
      display: none;
    }
  }

  // Small screens
  @media only screen and (min-width: ${props => props.smScreen}) {
    font-size: 0.9rem;
  }
  // Medium screens
  @media only screen and (min-width: ${props => props.mdScreen}) {
    font-size: 1rem;
  }
  // Large screens
  @media only screen and (min-width: ${props => props.lgScreen}) {
  }
  // Extra Large screens
  @media only screen and (min-width: ${props => props.xlScreen}) {
  }
  // Wider screens
  @media only screen and (min-width: ${props => props["2xlScreen"]}) {
  }
`

ThemeBreadcrumbs.defaultProps = {
  fullSupport: false,
  fullNegativeMargin: "0",
  smScreen: "640px",
  mdScreen: "768px",
  lgScreen: "1024px",
  xlScreen: "1280px",
  "2xlScreen": "1536px",
}

export default ThemeBreadcrumbs
